var r=0,a=1,e=2;export{r as LARGE_SIZE_LAYOUT,a as MEDIUM_SIZE_LAYOUT,e as SMALL_SIZE_LAYOUT};
